"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualPaymentPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PanelDashed_1 = require("../../../components/PanelDashed");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var core_1 = require("@athena-portal/core");
var CheckboxWidget_1 = require("../../CheckboxWidget");
var reactstrap_1 = require("reactstrap");
var ModalFooter_1 = require("reactstrap/lib/ModalFooter");
var AnnualPaymentPanelWidget = exports.AnnualPaymentPanelWidget = /** @class */ (function (_super) {
    __extends(AnnualPaymentPanelWidget, _super);
    function AnnualPaymentPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.termsAndConditionsText = "I confirm the cover I’ve chosen meets my needs and all the information I’ve given is correct. I understand that if any details I’ve given are false or inaccurate, or if we identify fraud, any claims I make could be rejected or not paid, and my insurance could be cancelled.";
        _this.renderPayButton = function (renderCancelChangesButton, reuseCard, paymentAmount) {
            var debtCombined = _this.getSetting("debtCombined") === "true";
            var onClickHandler = (reuseCard && !debtCombined) ?
                function (event) { return _this.handleOnClick(event, _this.props.interaction.policyHolder.cardDetails[0].number); } :
                _this.navigateToDifferentCard;
            var buttonId = reuseCard ? "card-1" : "pay-with-new-card";
            var payButtonClass = "btn btn-primary";
            payButtonClass += renderCancelChangesButton ? " btn-next" : " btn-make-payment m-auto";
            if (_this.isShowTerms && !_this.state.isAgreeToTerms && !_this.props.interaction.agreeToTermsAndConditions) {
                payButtonClass += " btn-disabled";
            }
            return React.createElement("button", { className: payButtonClass, onClick: onClickHandler, id: buttonId }, "Pay ".concat((0, commonFunctions_1.getAmountToDisplay)(paymentAmount)));
        };
        _this.renderTermsAndPayment = function (reuseCard, paymentAmount) {
            return React.createElement(React.Fragment, null,
                _this.isShowTerms && _this.renderTermsAndConditions(),
                _this.isShowTerms && _this.renderTermsPopup(),
                React.createElement("div", { className: "card-buttons" }, _this.renderPaymentButtons(reuseCard, paymentAmount)));
        };
        _this.renderPaymentButtons = function (reuseCard, paymentAmount) {
            // if setting is present, will render Cancel changes button in widget and change button classes to align them
            // change event is triggered on click, so navigation is done through onChange in widget commands on according page
            var renderCancelChangesButton = _this.getSetting("renderCancelChangesButton", false);
            return React.createElement(React.Fragment, null,
                renderCancelChangesButton && _this.renderCancelChangesButton(),
                _this.renderPayButton(renderCancelChangesButton, reuseCard, paymentAmount));
        };
        _this.handleOnCheckboxChange = function (event) {
            _this.setState({
                isAgreeToTerms: event.target.checked,
            });
        };
        _this.navigateToDifferentCard = function () {
            if (_this.isShowTerms && !_this.state.isAgreeToTerms) {
                _this.openTermsPopup();
            }
            else {
                _this.navigateToNewPaymentCardPage();
            }
        };
        _this.openTermsPopup = function () {
            _this.setState({ showTermsPopup: true });
        };
        _this.closeTermsPopup = function () {
            _this.setState({ showTermsPopup: false });
        };
        _this.navigateToNewPaymentCardPage = function () {
            var newCardPaymentPage = _this.getSetting("newCardPaymentPage");
            if (newCardPaymentPage) {
                _this.props.engine.navigate(newCardPaymentPage, true);
            }
        };
        _this.renderCancelChangesButton = function () {
            return (React.createElement("button", { className: "btn btn-white btn-back", onClick: _this.triggerChangeEventOnCancelChanges }, "Cancel changes"));
        };
        _this.triggerChangeEventOnCancelChanges = function () {
            var renderCancelChangesButton = _this.getSetting("renderCancelChangesButton");
            if (renderCancelChangesButton) {
                _this.executeEvent('change');
            }
        };
        _this.renderCardInformation = function () {
            var card = _this.findMainPaymentCard();
            if (card) {
                return (React.createElement("div", { className: "d-flex justify-content-center mt-3" },
                    React.createElement("div", { className: "card-details-wrapper" },
                        React.createElement("span", { className: "pr-2" }, _this.renderCardImage(card)),
                        "\u00A0",
                        React.createElement("span", null, _this.renderCardTypeName(card)),
                        "\u00A0",
                        React.createElement("span", null,
                            "ending in ",
                            React.createElement("b", null, card.number.split('******')[1])))));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.renderCardImage = function (card) {
            if (card.type.includes("VISA")) {
                return React.createElement("img", { className: "payment-icon", alt: "Visa icon", src: "/img/visa-icon.svg" });
            }
            if (card.type.includes("MASTERCARD")) {
                return React.createElement("img", { className: "payment-icon", alt: "Mastercard icon", src: "/img/mastercard-icon.svg" });
            }
            return React.createElement(React.Fragment, null);
        };
        _this.renderCardTypeName = function (card) {
            if (card.type.includes("VISA")) {
                return "Visa";
            }
            if (card.type.includes("MASTERCARD")) {
                return "Mastercard";
            }
            return "";
        };
        _this.setState({
            paymentCard: new services_1.PaymentCard(),
            isAgreeToTerms: _this.props.interaction.agreeToTermsAndConditions || false,
            showTermsPopup: false,
        });
        var process = _this.props.interaction.process;
        _this.isShowTerms = _this.props.interaction.product === services_1.PRODUCT_WOLF_MOTOR && (!(0, commonFunctions_1.isRenewal)(process))
            && _this.getSetting("isShowTerms", true);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    AnnualPaymentPanelWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getMainPaymentCard(this.props.interaction.agreementNumber).subscribe(function (paymentCard) {
            _this.setState({
                paymentCard: paymentCard
            });
        });
    };
    AnnualPaymentPanelWidget.prototype.render = function () {
        var _a;
        var additionalPremium = this.props.interaction.factors.additionalPremium;
        var premium = this.props.interaction.factors.premium;
        var deposit = services_1.productHelper.isHomeOrWolfMotor(this.props.interaction) ?
            this.props.interaction.paymentDetails.instalmentPlan.deposit : 0;
        var showRenewalAnnualPremium = this.getSetting("showRenewalAnnualPremium");
        if (((_a = this.state) === null || _a === void 0 ? void 0 : _a.paymentCard) === undefined) {
            return React.createElement(components_1.Overlay, { show: true });
        }
        else {
            return (React.createElement(React.Fragment, null, (additionalPremium !== 0 && this.renderPaymentContent()) || (premium !== 0 && this.renderPaymentContent()) || (deposit !== 0 && this.renderPaymentContent()) || (showRenewalAnnualPremium != null && this.renderPaymentContent())));
        }
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentContent = function () {
        return (React.createElement(PanelDashed_1.PanelDashed, { className: "bg-white text-center pay-by-card-panel" }, this.renderPaymentOptionsForCustomerPortal(this.props.interaction, (0, commonFunctions_1.getInteractionPaymentAmount)(this.props.interaction, this.getSetting("payUpfrontInterest") === "true", this.getSetting("debtCombined") === "true"))));
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentOptionsForCustomerPortal = function (interaction, paymentAmount) {
        var _a;
        var reuseCard = ((_a = this.state.paymentCard) === null || _a === void 0 ? void 0 : _a.reuseCard) || false;
        return reuseCard ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "panel-dashed-contents card-information" }, this.renderCardInformation()),
            React.createElement("div", { className: "pb-2 or-divider" }, " OR "),
            React.createElement("div", { className: "simple-link no-outline use-different-cart-link", id: "changeCard", "aria-label": "Use a different card to pay", onClick: this.navigateToDifferentCard, onKeyDown: this.navigateToDifferentCard, "aria-hidden": true }, "Use a different card"),
            this.renderTermsAndPayment(reuseCard, paymentAmount))) : (React.createElement("div", null, this.renderTermsAndPayment(reuseCard, paymentAmount)));
    };
    AnnualPaymentPanelWidget.prototype.renderTermsAndConditions = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "terms-conditions-title" }, "Terms and Conditions"),
            React.createElement(CheckboxWidget_1.default, { callback: this.handleOnCheckboxChange, defaultValue: this.props.interaction.agreeToTermsAndConditions, label: this.termsAndConditionsText })));
    };
    AnnualPaymentPanelWidget.prototype.renderTermsPopup = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.closeTermsPopup });
        return (React.createElement(reactstrap_1.Modal, { className: "info-modal", isOpen: this.state.showTermsPopup, style: { maxWidth: '816px' } },
            React.createElement(reactstrap_1.ModalHeader, { close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon" }),
                    React.createElement("span", { className: "text-blue-2 fs-20 font-weight-medium" }, "Before changing your payment card.."))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("p", { className: "font-weight-extra-light" }, "I confirm the cover I've chosen meets my needs and all the information I've given is correct. I understand that if any details I've given are false or inaccurate, or if we identify fraud, any claim I make could be rejected or not paid, and my insurance could be cancelled.")),
            React.createElement("div", { className: "empty-column" }),
            React.createElement(ModalFooter_1.default, { className: "d-block" },
                React.createElement("button", { type: "button", className: "btn btn-white", onClick: this.closeTermsPopup }, "Cancel"),
                React.createElement("button", { type: "button", className: "btn btn-primary", onClick: this.navigateToNewPaymentCardPage }, "Confirm & continue"))));
    };
    AnnualPaymentPanelWidget.prototype.handleOnClick = function (event, cardNumber) {
        var interaction = this.props.engine.getInteraction();
        var paymentDetails = interaction.paymentDetails;
        paymentDetails.cardNumber = cardNumber;
        this.props.engine.callInteractionSetState(__assign(__assign({}, this.props.engine.getInteraction()), { paymentDetails: paymentDetails }));
        this.executeEvent('click');
        event.preventDefault();
    };
    AnnualPaymentPanelWidget.prototype.findMainPaymentCard = function () {
        var card = {};
        if (services_1.productHelper.isHomeOrWolfMotor(this.props.interaction) &&
            this.props.interaction.policyHolder.cardDetails.length !== 0) {
            card = this.props.interaction.policyHolder.cardDetails[0];
            return card;
        }
        return null;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualPaymentPanelWidget.prototype, "customerPortalService", void 0);
    AnnualPaymentPanelWidget = __decorate([
        components_1.authorize,
        (0, journey_model_1.settings)([
            { name: "payUpfrontInterest", type: journey_model_1.TypeDescriptions.String },
            { name: "debtCombined", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualPaymentPanelWidget);
    return AnnualPaymentPanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualPaymentPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/AnnualPaymentPanelWidget.js
// module id = 3462
// module chunks = 0